import React from 'react';

// @atlaskit
import PageHeader from '@atlaskit/page-header';

const Header = () => (
  <PageHeader
    bottomBar={
      <p>Please select your report to see the excel or csv output.</p>
    }
  >
    Please adjust the settings to reporting.
  </PageHeader>
);

export default Header;
